import * as React from 'react';

interface PrintIconProps {
  color?: string;
}

const PrintIcon: React.FC<PrintIconProps> = ({ color }) => {
  return (
    <div>
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.3529 14.5H19C19.9428 14.5 20.4142 14.5 20.7071 14.2071C21 13.9142 21 13.4428 21 12.5V11.5C21 9.61438 21 8.67157 20.4142 8.08579C19.8284 7.5 18.8856 7.5 17 7.5H7C5.11438 7.5 4.17157 7.5 3.58579 8.08579C3 8.67157 3 9.61438 3 11.5V13.5C3 13.9714 3 14.2071 3.14645 14.3536C3.29289 14.5 3.5286 14.5 4 14.5H5.64706"
          stroke={color || 'currentColor'}
          strokeWidth="2"
        />
        <path
          d="M6 20.8063L6 12.5C6 11.5572 6 11.0858 6.29289 10.7929C6.58579 10.5 7.05719 10.5 8 10.5L16 10.5C16.9428 10.5 17.4142 10.5 17.7071 10.7929C18 11.0858 18 11.5572 18 12.5L18 20.8063C18 21.1228 18 21.2811 17.8962 21.356C17.7924 21.4308 17.6422 21.3807 17.3419 21.2806L15.1581 20.5527C15.0798 20.5266 15.0406 20.5135 15 20.5135C14.9594 20.5135 14.9202 20.5266 14.8419 20.5527L12.1581 21.4473C12.0798 21.4734 12.0406 21.4865 12 21.4865C11.9594 21.4865 11.9202 21.4734 11.8419 21.4473L9.15811 20.5527C9.07975 20.5266 9.04057 20.5135 9 20.5135C8.95943 20.5135 8.92025 20.5266 8.84189 20.5527L6.65811 21.2806C6.3578 21.3807 6.20764 21.4308 6.10382 21.356C6 21.2811 6 21.1228 6 20.8063Z"
          stroke={color || 'currentColor'}
          strokeWidth="2"
        />
        <path
          d="M18 7.5V6.38C18 5.37191 18 4.86786 17.8038 4.48282C17.6312 4.14413 17.3559 3.86876 17.0172 3.69619C16.6321 3.5 16.1281 3.5 15.12 3.5H8.88C7.87191 3.5 7.36786 3.5 6.98282 3.69619C6.64413 3.86876 6.36876 4.14413 6.19619 4.48282C6 4.86786 6 5.37191 6 6.38V7.5"
          stroke={color || 'currentColor'}
          strokeWidth="2"
        />
        <path d="M10 14.5L13 14.5" stroke={color || 'currentColor'} strokeWidth="2" strokeLinecap="round" />
        <path d="M10 17.5L14.5 17.5" stroke={color || 'currentColor'} strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export { PrintIcon };
